import React from "react";
import styles from "../Modules/ProjectCard.module.css";

class ProjectCard extends React.Component {
  render() {
    const {
      name,
      description,
      previewImage,
      demo,
      gitRepo,
      viewCode,
      imgAlt,
      projectInfoPath,
      projectTechnologies,
      demoVideo
    } = this.props;

    return (
        <div className={styles.card} id={name}>
          <h4 className={styles.projName}>{name}</h4>
          <div className={styles.container}>
            <img src={previewImage} className={styles.previewImage} alt={imgAlt || ""}/>
            <div className={styles.text}>
              <div className={styles.technologies}>
                {projectTechnologies.map((tech) => {
                  return <span key={tech}>{tech}</span>;
                })}
              </div>
              <p className={styles.description}>{description}</p>
              <div className={styles.buttons}>
                {demo ?
                    <a
                        className={styles.card_link}
                        href={demo}
                        target="_blank"
                        rel="noopener noreferrer"
                        title="Use this project"
                    >
                      Use this project
                    </a>
                    :
                    <></>
                }
                {demoVideo ?
                    <a
                        className={styles.card_link}
                        href={demoVideo}
                        target="_blank"
                        rel="noopener noreferrer"
                        title="Use this project"
                    >
                      Watch Demo Video
                    </a>
                    :
                    <></>
                }
                <a
                    className={styles.card_link}
                    href={gitRepo}
                    title="Details"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                  Source code
                </a>
                <a
                    className={styles.card_link}
                    href={projectInfoPath}
                    rel="noopener noreferrer"
                >
                  Read more
                </a>
              </div>
            </div>
          </div>
        </div>
    );
  }
}

export default ProjectCard;
